import { createAction } from 'redux-actions'

import {
  RESET_SELECTED_STYLE_COLORS,
  TOGGLE_ALL_STYLE_COLORS,
  TOGGLE_STYLE_COLOR,
} from './constants'

export const toggleAllStyleColors = createAction(TOGGLE_ALL_STYLE_COLORS)
export const toggleStyleColor = createAction(TOGGLE_STYLE_COLOR)
export const resetSelectedStyleColors = createAction(
  RESET_SELECTED_STYLE_COLORS,
)
